import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigAdmin";
import Constant from "../../constants";
import { Link } from "react-router-dom";

export default class CreateFinanceUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        name: "",
        mobile_number: "",
        email: "",
        password: "",
        status: "",
      },
      errors: {},
      type: "password",
      img: "/images/doctor-img/Login screens/hide_icon.svg",
      pageHeading: "Create User",
    };
  }

  // To get detais after first render
  componentDidMount() {
    const { handle } = this.props.match.params;
    if (handle) {
      this.setState({ pageHeading: "Update User" });
      this.getFinanceUserInfo(handle);
    }
  }

  // When value changes of the fields
  handleChange = (field, event) => {
    const value = event.target.value;
    this.setState((prevState) => ({
      fields: {
        ...prevState.fields,
        [field]: value,
      },
    }));
  };

  //  For select
  onSelect = (selectedListdata, selectedItem) => {
    this.setState({
      selectedLangName: selectedListdata.map((x) => x.name),
    });
    this.setState({
      selectedLangId: selectedListdata.map((x) => x.id),
      selectedList: selectedListdata.map((x) => x.id),
    });
  };
  //  For remove
  onRemove = (deselectedList, removedItem) => {
    this.setState({
      selectedList: deselectedList.map((x) => x.id),
    });
  };

  // To get all the ResponderInfo
  getFinanceUserInfo(handle) {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/finance/" + handle
    )
      .then((response) => {
        const data = response.data.data;
        // Prefill all fields from the response data object
        this.setState({ fields: { ...data } });
      })
      .catch(() => {});
  }

  // create or update
  checkSubmit = (event) => {
    event.preventDefault();
    const { handle } = this.props.match.params;
    if (this.handleValidation()) {
      if (handle) {
        this.updateFinanceUser();
      } else {
        this.createFinanceUser();
      }
    } else {
      toast.warn("Form has errors.");
    }
  };
  // creates new controller
  createFinanceUser = () => {
    const { fields } = this.state;
    Httpconfig.httptokenpost(Constant.siteurl + "api/finance/", {
      name: fields.name,
      mobile_number: fields.mobile_number,
      email: fields.email,
      password: fields.password,
      user_type: "finance",
      status: fields.status,
    })
      .then((response) => {
        if (response.data.status === 204) {
          toast.error(response.data.message);
        } else {
          toast.success("Successfully Created Finance User");
          setTimeout(
            () => this.props.history.push("/admin/ViewFinanceUsers"),
            1000
          );
        }
      })
      .catch(() => {});
  };

  updateFinanceUser = () => {
    const { fields } = this.state;
    const { handle } = this.props.match.params;
    Httpconfig.httptokenput(Constant.siteurl + "api/finance/" + handle, {
      name: fields.name,
      mobile_number: fields.mobile_number,
      email: fields.email,
      password: fields.password,
      user_type: "finance",
      status: fields.status,
    })
      .then((response) => {
        toast.success("Successfully Updated Finance User");
        setTimeout(
          () => this.props.history.push("/admin/ViewFinanceUsers"),
          1000
        );
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  //  For validating the fields
  handleValidation = () => {
    const { fields } = this.state;
    let errors = {};
    let formIsValid = true;

    if (!fields.email) {
      formIsValid = false;
      errors.email = "Email cannot be empty";
    } else {
      const lastAtPos = fields.email.lastIndexOf("@");
      const lastDotPos = fields.email.lastIndexOf(".");
      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          fields.email.indexOf("@@") === -1 &&
          lastDotPos > 2 &&
          fields.email.length - lastDotPos > 2
        )
      ) {
        formIsValid = false;
        errors.email = "Email is invalid";
      }
    }
    if (!fields.password) {
      formIsValid = false;
      errors.password = "Password cannot be empty";
    } else if (fields.password.length < 8 || fields.password.length > 20) {
      formIsValid = false;
      errors.password = "Password should contain 8-20 characters";
    } else if (
      !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20}$/.exec(
        fields.password
      )
    ) {
      formIsValid = false;
      errors.password =
        "Required one upper case, one small case, one number and one special character";
    }
    if (!fields.mobile_number) {
      formIsValid = false;
      errors.mobile_number = "Phone number cannot be empty";
    } else if (fields.mobile_number.length < 10) {
      formIsValid = false;
      errors.mobile_number = "Phone number invalid";
    }
    if (!fields.name) {
      formIsValid = false;
      errors.name = "Name cannot be empty";
    } else if (/\d/.test(fields.name)) {
      formIsValid = false;
      errors.name = "Please enter only letters, numbers not allowed.";
    }
    if (!fields.status) {
      formIsValid = false;
      errors.status = "Please select status";
    }
    this.setState({ errors });
    return formIsValid;
  };

  //  For showing password
  showPassword = () => {
    this.setState((prevState) => ({
      type: prevState.type === "input" ? "password" : "input",
      img:
        prevState.type === "input"
          ? "/images/doctor-img/Login screens/hide_icon.svg"
          : "/images/doctor-img/Login screens/unhide_icon.svg",
    }));
  }

  //  for entering the value

  render() {
    const {
      fields,
      errors,
      specialities_data,
      clinic_details,
      countryData,
    } = this.state;

    const { handle } = this.props.match.params;
    const isEditMode = Boolean(handle);
    return (
      <section id="main_dashboard">
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
                <div className="section-header">
                  <ol className="breadcrumb">
                    <li className="active">
                      <Link to="/admin"> Dashboard</Link> &gt;
                      <a> Finance </a>
                    </li>
                  </ol>
                </div>
              </div>

              <section id="CMS_tab">
                <div className="CMS_content">
                  <div className="container">
                    <div className="row">
                      <div className="tab-header">
                        <h3>{this.state.pageHeading} </h3>
                      </div>
                      <div id="reg_form">
                        <form onSubmit={this.checkSubmit.bind(this)}>
                          <div className="row">
                            <div className="col-md-3">
                              <div className="form-group ">
                                <label>Name</label>
                                <input
                                  name="name"
                                  value={this.state.fields["name"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "name"
                                  )}
                                  className="form-control"
                                  placeholder="Name"
                                  type="text"
                                  disabled={isEditMode}
                                />
                                <span className="cRed">
                                  {this.state.errors["name"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="form-group">
                                <label>Mobile Number</label>
                                <input
                                  type="text"
                                  name="mobile_number"
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  minLength="10"
                                  maxlength="10"
                                  value={
                                    this.state.fields["mobile_number"] || ""
                                  }
                                  onChange={this.handleChange.bind(
                                    this,
                                    "mobile_number"
                                  )}
                                  className="form-control"
                                  placeholder="Mobile Number"
                                  disabled={isEditMode}
                                />
                                <span className="cRed">
                                  {this.state.errors["mobile_number"]}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-3">
                              <div className="form-group">
                                <label>email</label>
                                <input
                                  type="text"
                                  name="email"
                                  autoComplete="new-password"
                                  value={this.state.fields["email"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "email"
                                  )}
                                  className="form-control"
                                  placeholder="Email"
                                  disabled={isEditMode}
                                />
                                <span className="cRed">
                                  {this.state.errors["email"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div className="form-group ">
                                <label>Password</label>
                                <input
                                  type={this.state.type}
                                  name="password"
                                  autoComplete="new-password"
                                  value={this.state.fields["password"] || ""}
                                  onChange={this.handleChange.bind(
                                    this,
                                    "password"
                                  )}
                                  className="form-control log_input"
                                  placeholder="password"
                                  disabled={isEditMode}
                                />
                                <img
                                  className="password_view"
                                  onClick={this.showPassword}
                                  src={this.state.img}
                                />
                                <span className="cRed">
                                  {this.state.errors["password"]}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-4 cr_mid">
                              <div className="form-group ">
                                <label
                                  htmlFor="customRadio2"
                                  className="custom-control-label"
                                >
                                  Status
                                </label>
                                <div
                                  className="custom-control custom-radio"
                                  onChange={this.handleChange.bind(
                                    this,
                                    "status"
                                  )}
                                >
                                  <input
                                    type="radio"
                                    value="1"
                                    checked={this.state.fields["status"] == "1"}
                                    name="status"
                                  />{" "}
                                  Active &nbsp;&nbsp;&nbsp;
                                  <input
                                    type="radio"
                                    value="0"
                                    checked={this.state.fields["status"] == "0"}
                                    name="status"
                                  />{" "}
                                  In Active
                                  <span className="cRed">
                                    {this.state.errors["status"]}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group ">
                                <input
                                  type="hidden"
                                  name="slot_duration"
                                  value="10"
                                  onChange={this.handleChange.bind(
                                    this,
                                    "slot_duration"
                                  )}
                                  className="form-control"
                                  placeholder="Slot Duration"
                                />
                                <span className="cRed">
                                  {this.state.errors["slot_duration"]}
                                </span>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <input
                                  type="hidden"
                                  name="break_duration"
                                  value="5"
                                  onChange={this.handleChange.bind(
                                    this,
                                    "break_duration"
                                  )}
                                  className="form-control"
                                  placeholder="Break Duration"
                                />
                                <span className="cRed">
                                  {this.state.errors["break_duration"]}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="row"></div>
                          <div className="row">
                            <div className="form-group col-md-12">
                              <button
                                type="submit"
                                className="btn  btn-primary save_btn"
                              >
                                Save User
                              </button>{" "}
                              &nbsp;
                              <Link
                                to="/admin/ViewFinanceUsers"
                                className="cancel_btn"
                              >
                                Cancel
                              </Link>{" "}
                              &nbsp; &nbsp;
                            </div>
                          </div>
                        </form>
                      </div>
                      <ToastContainer />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
